export default {
    slug: 'bo/options',
    title: 'Options',
    visible: [
        'label',
        'uuid'
    ],
    listview: 'OptionsListView',
    locales: ['common'],
    columns: [
        {
            key: 'label',
            label: 'Label',
            main: true,
        }
    ],
    actions: {
        create: {
            title: 'Add new',
            level: 'highlight',
            icon: 'plus-circle',
            vm: 'addNewOption'
        },
        details: {
            title: 'Details',
            class: 'btn btn-default',
            level: 'row',
            vm: 'openOptionDetails'
        }
    },
    copyColumns: [
        'uuid'
    ],
    tooltipColumns: [
        'uuid'
    ]
}



// WEBPACK FOOTER //
// ./src/app/store/bookable-objects/options/state.js